// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"07a9a612","194":"c3fd3a0c","260":"42760bf8","668":"7bc632a4","762":"e715be6a","810":"6344f814","811":"7280a898","902":"7cb14cdf","973":"31eb1c59","983":"908938b7"}[chunkId] + ".js";
};